<div class="mb-4">
  <app-alerts />
</div>

<div class="space-y-5">
  <div class="grid grid-cols-1 gap-4 xl:grid-cols-2">
    <app-form-control label="Wielkość przesyłki">
      <p-select
        [formControl]="form.controls.size"
        [options]="valueOrDefault(shipmentSizeSelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true" />
    </app-form-control>

    <app-form-control label="Planowana data wysyłki">
      <p-date-picker
        [formControl]="form.controls.scheduledShippingDate"
        dateFormat="yy-mm-dd" />
    </app-form-control>
  </div>

  <app-form-control label="Komentarz / uwagi">
    <textarea
      [formControl]="form.controls.comment"
      appPrimengTextarea
      pTextarea
      rows="5"></textarea>
  </app-form-control>

  <app-form-control label="Kosmetyki">
    <app-admin-order-shipment-items-control
      [formControl]="form.controls.cosmetics"
      [label]="'Kosmetyki'"
      [type]="shipmentItemType.Cosmetic" />
  </app-form-control>

  <app-form-control label="Boxy kosmetyczne">
    <app-admin-order-shipment-items-control
      [formControl]="form.controls.boxes"
      [label]="'Boxy kosmetyczne'"
      [type]="shipmentItemType.Box" />
  </app-form-control>

  <app-form-control label="Produkty">
    <app-admin-order-shipment-items-control
      [formControl]="form.controls.products"
      [label]="'Produkty'"
      [type]="shipmentItemType.Product" />
  </app-form-control>
</div>

<div class="mt-5 flex justify-end gap-4">
  <p-button
    (onClick)="handleCancelButtonClick()"
    appPrimengButton
    label="Anuluj"
    type="button"
    variant="outlined" />

  <p-button
    (onClick)="handleSubmitButtonClick()"
    [disabled]="form.invalid"
    appPrimengButton
    label="Zapisz"
    type="submit" />
</div>
